import { SalesStageTypesState } from './types';
import { RootState } from 'store/root-reducer';
import { createSelector } from '@reduxjs/toolkit';

const selectSalesStageTypesReducer = (state: RootState): SalesStageTypesState => state.salesStageTypes;

export const selectSalesStageTypesIsEmpty = createSelector(
  [selectSalesStageTypesReducer],
  (salesStageTypes) => salesStageTypes.salesStageTypesIsEmpty
);

export const selectSalesStageTypesLoading = createSelector(
  [selectSalesStageTypesReducer],
  (salesStageTypes) => salesStageTypes.salesStageTypesLoading
);

export const selectSalesStageTypes = createSelector(
  [selectSalesStageTypesReducer],
  (salesStageTypes) => salesStageTypes.salesStageTypes
);
